import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { BackendService } from '../../core/backend.service';
import { UserCatalog, UserCatalogItem } from './user-catalog';

@Injectable({
  providedIn: 'root',
})
export class UserCatalogService {

  public catalogList: Subject<UserCatalogItem[]> = new Subject();

  constructor(private backenService: BackendService) {

  }

  public GetUserCatalogs() {

    this.backenService.get<UserCatalog>(UserCatalog).subscribe(result => {
      this.catalogList.next(result.catalogList);
    });

  }
}
